import ReimbursementSummaryLeadAccounts from '@deere/cps-it.warranty-model-factory/lib/reimbursement-summary';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateLeadAccounts = (state, action) =>
    ReimbursementSummaryLeadAccounts.update(state, {
        $set: action.payload
    });

export default (state = getDefaultState().leadAccounts, action) => {

    const actionTypes = {
        [actions.READ_REIMBURSEMENT_SUMMARY_SUCCESS]: updateLeadAccounts
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/reducers/lead-accounts.js